<div class="dropdownlist">


    <div class="dropdown">
        <select class="dropdown" [(ngModel)]="shipCode">
            <option value="" disabled selected hidden>---Select a Ship---</option>
            <option class="dropdown" *ngFor="let ship of allshipnames" value={{ship.Code}}> {{ship.Name}}</option>
        </select>
    </div>

</div>

<div class="homebutton center">
    <button mat-stroked-button class="btn btn-primary btn-lg" (click)="GetCurrentCruiseForShip()"
        [disabled]="shipCode==''">Access American
        Explorer</button>
</div>

<!-- <div class="buttonarea d-flex justify-content-center">

    <button type="button" (click)="login($event)" class="btn btn-primary btn-lg" [disabled]="!heroForm.valid">LOG
        IN</button>

</div> -->